<template>
    <div class="mask-layout union-zoom">
        <img :class="'zoom-show'" :src="catchCurImg">
        <i class="zoom-close" @click="closeZoom">×</i>
        <div class="zoom-pagination-panel" v-if="isGroup && groupUrl.length > 0">
            {{catchIndex + 1}} / {{groupUrl.length}}
        </div>
        <div class="zoom-switch-panel previous" v-if="isGroup && groupUrl.length > 0 && catchIndex > 0">
            <i class="switch-handle" @click="switchCurImg(1)">&lt;</i>
        </div>
        <div class="zoom-switch-panel next" v-if="isGroup && groupUrl.length > 0 && catchIndex < groupUrl.length - 1">
            <i class="switch-handle" @click="switchCurImg(2)">&gt;</i>
        </div>
    </div>
</template>
<style>
.union-zoom {
    z-index: 5000;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    color: #ffffff;
}
.union-zoom .zoom-show-wrap{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
}
.union-zoom .zoom-show{
    max-width: 100%;
    max-height: 100%;
    transition: all 0.3s ease;
}
.union-zoom .zoom-close{
    width: 1rem;
    height: 1rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 99;
    font-size: 0.9rem;
    font-weight: normal;
    text-shadow: 0 0 5px rgba(255, 255, 255, 0.5), 
    0 0 10px rgba(255, 255, 255, 0.5), 
    0 0 15px rgba(255, 255, 255, 0.5), 
    0 0 20px rgba(34, 141, 255, 0.5), 
    0 0 35px rgba(34, 141, 255, 0.5), 
    0 0 40px rgba(34, 141, 255, 0.5), 
    0 0 50px rgba(34, 141, 255, 0.5), 
    0 0 75px rgba(34, 141, 255, 0.5);
}
.union-zoom .zoom-switch-panel{
    width: 0.8rem;
    height: 100%;
    position: absolute;
    top: 0;
    z-index: 19;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.union-zoom .zoom-switch-panel .switch-handle{
    width: 100%;
    height: 0.8rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    font-size: 0.6rem;
    text-shadow: 0 0 5px rgba(255, 255, 255, 0.5), 
    0 0 10px rgba(255, 255, 255, 0.5), 
    0 0 15px rgba(255, 255, 255, 0.5), 
    0 0 20px rgba(34, 141, 255, 0.5), 
    0 0 35px rgba(34, 141, 255, 0.5), 
    0 0 40px rgba(34, 141, 255, 0.5), 
    0 0 50px rgba(34, 141, 255, 0.5), 
    0 0 75px rgba(34, 141, 255, 0.5);
}
.union-zoom .zoom-switch-panel.previous{
    left: 0;
}
.union-zoom .zoom-switch-panel.previous .switch-handle{
    border-top-right-radius: 0.2rem;
    border-bottom-right-radius: 0.2rem;
}
.union-zoom .zoom-switch-panel.next{
    right: 0;
}
.union-zoom .zoom-switch-panel.next .switch-handle{
    border-top-left-radius: 0.2rem;
    border-bottom-left-radius: 0.2rem;
}
.union-zoom .zoom-pagination-panel{
    width: 100%;
    height: 1rem;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 9;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-size: 0.46rem;
    text-shadow: 0 0 5px rgba(255, 255, 255, 0.5), 
    0 0 10px rgba(255, 255, 255, 0.5), 
    0 0 15px rgba(255, 255, 255, 0.5), 
    0 0 20px rgba(34, 141, 255, 0.5), 
    0 0 35px rgba(34, 141, 255, 0.5), 
    0 0 40px rgba(34, 141, 255, 0.5), 
    0 0 50px rgba(34, 141, 255, 0.5), 
    0 0 75px rgba(34, 141, 255, 0.5);
}
</style>
<script>
export default {
    props: {
        curImg: { //当前图片
            type: String,
            default: ""
        },
        isGroup: { //是否有图组
            type: Boolean,
            default: false
        },
        groupUrl: { //图片组列表
            type: Array,
            default: []
        },
        curIndex: { //当前图片在图片组中的索引值
            type: Number,
            default: 0
        },
        imgUrl: { //图片路径字段名称
            type: String,
            default: "ImageUrl"
        },
    },
    data() {
        return {
            catchIndex: 0,
            catchCurImg: "",
        };
    },
    mounted() {
        this.catchIndex = this.curIndex;
        this.catchCurImg = this.curImg;
    },
    methods: {
        //关闭
        closeZoom(){
            this.$emit("closeZoom");
        },
        //切换当前图片
        switchCurImg(type){
            if(parseInt(type) == 1){ //上一张
                if(this.isGroup && this.groupUrl.length > 0 && this.catchIndex > 0){
                    this.catchIndex--;
                    this.catchCurImg = this.groupUrl[this.catchIndex][this.imgUrl];
                }
            } else if(parseInt(type) == 2){ //下一张
                if(this.isGroup && this.groupUrl.length > 0 && this.catchIndex < this.groupUrl.length - 1){
                    this.catchIndex++;
                    this.catchCurImg = this.groupUrl[this.catchIndex][this.imgUrl];
                }
            }
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/shared/components/zoom/zoom.vue